import React from "react";
import { Component } from "react";
import SliderFilter from "../SliderFilter/SliderFilter";
import ModalFilter from "../ModalFilter/ModalFilter";
import MobileFilter from "../MobileFilter/MobileFilter";
import ColourFilterTile from "../ColourFilterTile/ColourFilterTile";
import SizeFilterTile from "../SizeFilterTile/SizeFilterTile";
import BrandFilterTile from "../BrandFilterTile/BrandFilterTile";
import {
  connectRefinementList,
  connectCurrentRefinements
} from "react-instantsearch-dom";
import PropTypes from "prop-types";
import "./FiltersModule.scss";
import ClearSelection from "../ClearSelection/ClearSelection";

const ColourFilterSlider = connectRefinementList(SliderFilter(ColourFilterTile));
const SizeFilterSlider = connectRefinementList(SliderFilter(SizeFilterTile));
const BrandFilterSlider = connectRefinementList(SliderFilter(BrandFilterTile));

const ColourFilterModal = connectRefinementList(ModalFilter(ColourFilterTile));
const SizeFilterModal = connectRefinementList(ModalFilter(SizeFilterTile));
const BrandFilterModal = connectRefinementList(ModalFilter(BrandFilterTile));

const ClearRefinementsAlgolia = connectCurrentRefinements(ClearSelection);

class FiltersModule extends Component {
  constructor(props) {
    super(props);

    this.selectedFilterCount = this.selectedFilterCount.bind(this);
    this.resetFilterFor = this.resetFilterFor.bind(this);
    this.closeModal = this.closeModal.bind(this);
    
    this.state = {
      mode: null,
      currentModalFilter: null,
      selectedFilters: {
        Colour: [],
        Brand: [],
        Size: []
      }
    };
    
  }

  resetFilterFor(label){
    this.setState({
      selectedFilters: Object.assign({}, this.state.selectedFilters, {
        [label]: []
      })
    });
  }

  closeModal() {
    this.setState({currentModalFilter: null});
    if(document){
      document.querySelector('body').classList.remove('modal-open');
    }
  }

  showModal(label) {
    this.setState({currentModalFilter: label});
    if(document){
      document.querySelector('body').classList.add('modal-open');
    }
  }

  componentDidMount() {
    
    if(window.innerWidth <= 640){
      if(this.state.mode !== "modals") this.setState({mode:"modals"});
    } else {
      if(this.state.mode !== "sliders") this.setState({mode:"sliders"});
    }

  }

  componentDidUpdate(prevProps) {
    if (!prevProps.filtersReset && this.props.filtersReset) {
      this.setState({
        selectedFilters: {
          Colour: [],
          Brand: [],
          Size: []
        }
      });
    }
  }

  getColours(){
    return this.props.colours ? this.props.colours : [];
  }

  getSizes(){
    return this.props.sizes ? this.props.sizes : [];
  }

  getBrands(){
    return this.props.brands ? this.props.brands : [];
  }

  selectedFilterCount() {
    return this.selectedColoursCount() + this.selectedSizesCount() + this.selectedBrandsCount();
  }

  selectedColoursCount(){
    return this.state.selectedFilters["Colour"].length;
  }

  selectedSizesCount(){
    return this.state.selectedFilters["Size"].length;
  }

  selectedBrandsCount(){
    return this.state.selectedFilters["Brand"].length;
  }


  onSelectedChange(label) {
    return selected => {

      const newSelectedFilters = { ...this.state.selectedFilters };
      newSelectedFilters[label] = selected;

      const noOfFilters =
        newSelectedFilters["Brand"].length +
        newSelectedFilters["Colour"].length +
        newSelectedFilters["Size"].length;

      if (noOfFilters > 0 && this.props.resetFilters) {
        this.props.resetFilters(false);
      }

      this.setState({
        selectedFilters: newSelectedFilters
      });

    };
  }

  sortAlphabetically(items) {
    return items && items.sort((a, b) => a.localeCompare(b));
  }

  render() {
    return (
      <div className="filters-module">
        <h3>Filter by colour, nib size and brand</h3>

        { this.state.mode === "sliders" && 
          <>
            <ColourFilterSlider
              label="Colour"
              attribute="colour"
              allItems={this.getColours()}
              onChange={this.onSelectedChange("Colour")}
              resetFilters={() => {this.resetFilterFor("Colour")}}
              limit={this.getColours().length + 1}
            />
          
            <SizeFilterSlider
              label="Nib size"
              attribute="sizeDescription"
              allItems={this.getSizes()}
              onChange={this.onSelectedChange("Size")}
              resetFilters={() => {this.resetFilterFor("Size")}}
              limit={this.getSizes().length + 1}
            />
          
            <BrandFilterSlider
              label="Brand"
              attribute="brand"
              allItems={this.sortAlphabetically(this.getBrands())}
              onChange={this.onSelectedChange("Brand")}
              resetFilters={() => {this.resetFilterFor("Brand")}}
              limit={this.getBrands().length + 1}
            />
          </>
        }

        { this.state.mode === "modals" &&
          <>            
            <MobileFilter 
              name="Colour" 
              selectedCount={this.selectedColoursCount()} 
              totalCount={this.getColours().length}
              onEdit={() => { this.showModal("Colour") }}
            />

            <ColourFilterModal
              active={this.state.currentModalFilter === "Colour"}
              label="Colour"
              attribute="colour"
              allItems={this.getColours()}
              onChange={this.onSelectedChange("Colour")}
              resetFilters={() => {this.resetFilterFor("Colour")}}
              limit={this.getColours().length}
              onClose={this.closeModal}
            />

            <MobileFilter 
              name="Nib size" 
              selectedCount={this.selectedSizesCount()} 
              totalCount={this.getSizes().length}
              onEdit={() => { this.showModal("Size")} }
            />

            <SizeFilterModal
              active={this.state.currentModalFilter === "Size"}
              label="Nib size"
              attribute="sizeDescription"
              allItems={this.getSizes()}
              onChange={this.onSelectedChange("Size")}
              resetFilters={() => {this.resetFilterFor("Size")}}
              limit={this.getSizes().length}
              onClose={this.closeModal}              
            />

            <MobileFilter 
              name="Brand" 
              selectedCount={this.selectedBrandsCount()} 
              totalCount={this.getBrands().length}
              onEdit={() => { this.showModal("Brand") }}
            />

            <BrandFilterModal
              active={this.state.currentModalFilter === "Brand"}
              label="Brand"
              attribute="brand"
              allItems={this.getBrands()}
              onChange={this.onSelectedChange("Brand")}
              resetFilters={() => {this.resetFilterFor("Brand")}}
              limit={this.getBrands().length}
              onClose={this.closeModal}
            />

          </>
        }

               
        { this.selectedFilterCount() > 0 && <div className="filters-module__footer"><ClearRefinementsAlgolia label="Reset all filters" resetFilters={(reset) => this.props.resetFilters(reset)} /></div> }
        
      </div>
    );
  }
}

FiltersModule.propTypes = {
  brands: PropTypes.array,
  sizes: PropTypes.array,
  colours: PropTypes.array
};

export default FiltersModule;
